export default __webpack_public_path__ + "static/media/WhiteFaceTagline.d26fe684.png";